import React from 'react';
import PropTypes from 'prop-types';

import { ContentZonesService } from '@sm360/widget-commons-core-services';

import ForgetPasswordForm from 'login/components/ForgetPassword/ForgetPasswordForm/ForgetPasswordForm.jsx';
import ModalHeader from 'login/components/Library/ModalHeader/ModalHeader.jsx';

const czGroupName = 'widget.login.forms.forgotpassword';

const ForgetPasswordContent = ({ className }) => {
    const headerTitleCz =
        ContentZonesService.getContentZone(czGroupName, 'maintext') &&
        ContentZonesService.getContentZone(czGroupName, 'maintext').getText();
    const headerTextCz =
        ContentZonesService.getContentZone(czGroupName, 'subtext') &&
        ContentZonesService.getContentZone(czGroupName, 'subtext').getText();

    return (
        <div className={`modal-login-content ${className}`}>
            <div id="forget-password" className="ForgetPasswordForm">
                <ModalHeader titleContentZone={headerTitleCz} textContentZone={headerTextCz} showImage showText />

                <ForgetPasswordForm />
            </div>
        </div>
    );
};

ForgetPasswordContent.defaultProps = {
    className: '',
};

ForgetPasswordContent.propTypes = {
    className: PropTypes.string,
};

ForgetPasswordContent.displayName = 'ForgetPasswordContent';

export default ForgetPasswordContent;
